import React, { useEffect, useState } from 'react'
import Category from "../../components/category";
import Partner from '../../components/partner';
import Footer from '../../components/footer';
import Gotop from '../../components/gotop';
import dataPartner from '../../assets/fakeData/dataPartner';
import dataCate from '../../assets/fakeData/dataCategory';
import CRHeader from '../../components/header/CRHeader';
import CRMobileHeader from '../../components/header/CRMobileHeader';
import TopCandidates from '../TopCandidates/TopCandidates';
import Banner07 from '../../components/banner/Banner07';
import { Helmet } from 'react-helmet';
import ReviewJob10 from '../../components/jobs/ReviewJob10';
import Box07 from '../../components/boxicon/Box07';
import TopInstitute from "../TopInstitute/TopInstitute"
import Couter from '../../components/iconbox/Couter';

const CRhomepage = () => {


  const [isShowMobile, setShowMobile] = useState(false);
  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

  return (
    <>
      <Helmet>
        <title>Home | Jobkikhoj</title>
        <meta name="description" content=" " />
        <meta name="keywords" content=" " />
        <meta property="og:title" content="Home | Jobkikhoj " />
        <meta property="og:description" content="" />
        <meta property="og:url" content="https://jobkikhoj.com" />
      </Helmet>
      <CRMobileHeader handleMobile={handleMobile} />
      <CRHeader clname="act1" handleMobile={handleMobile} />
      <div className="pt-70">
        <Banner07 />
        <Box07 />       
        <ReviewJob10 />
        <Couter/>
        {/* <Category data={dataCate}  title= "Browse by category"  text= "Recruitment Made Easy in 100 seconds"/> */}
        <TopCandidates className="pt-3 pb-3" />
        <TopInstitute />
        <Partner data={dataPartner} />
        <Footer />
        <Gotop />
      </div>
    </>
  )

}

export default CRhomepage